import Section from '../components/Section';
import QuestionForm from '../components/QuestionForm';
import Arrow from '../components/Arrow';
import { useLanguage } from '../context/LanguageContext';

const WHATSAPP_INVITE = 'https://chat.whatsapp.com/';

const EXAMPLES = [
  'Everyone says diversify. How much is too much?',
  'Is it a bad time to start a SIP when markets are at a high?',
  "How is Napho's advice different from a fund distributor's?",
];

export default function AskNapho() {
  const { t } = useLanguage();
  return (
    <Section eyebrow={t('ask.eyebrow')} title={t('ask.title')} lead={t('ask.lead')}>
      <div className="grid grid-2" style={{ alignItems: 'start' }}>
        <div className="card">
          <h3 className="card__title">{t('ask.placeholder')}</h3>
          <QuestionForm />
        </div>

        <div className="stack">
          <div className="card card--hover">
            <h3 className="card__title">Join the community</h3>
            <p style={{ marginBottom: '1.25rem' }}>
              Pain points are discussed openly with real users while we build.
              Come in, listen, and help shape the product.
            </p>
            <a className="btn btn--primary" href={WHATSAPP_INVITE} target="_blank" rel="noreferrer">
              {t('ask.whatsapp')} <Arrow className="btn__arrow" />
            </a>
          </div>

          <div className="card">
            <h3 className="card__title">{t('ask.examples')}</h3>
            <ul className="ask-examples">
              {EXAMPLES.map((q) => (
                <li key={q}>“{q}”</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  );
}
